<div style="display: block;">
  <canvas #chartCanvas baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="barChartType">
  </canvas>
</div>
